import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
  }

  reset = () => this.setState({ hasError: false, error: null, info: null });

  goHome = () => { window.location.href = "/dashboard"; };

  reload = () => { window.location.reload(); };

  render() {
    if (!this.state.hasError) return this.props.children;

    const errMsg = String(this.state.error?.message || this.state.error || "Erreur inconnue");
    const stack = this.state.error?.stack || "";

    return (
      <div className="min-h-screen flex items-center justify-center bg-white text-[#0B0F19] p-4" data-testid="error-boundary">
        <div className="max-w-lg w-full border-2 border-[#0B0F19] p-6">
          <p className="overline text-red-600">Erreur inattendue</p>
          <h1 className="font-heading font-black text-2xl tracking-tight mt-2 mb-3">Oups, quelque chose a mal tourné</h1>
          <p className="text-sm text-gray-600 mb-3">
            L'application a rencontré une erreur. Essayez de recharger la page ou de retourner au tableau de bord.
          </p>
          <div className="bg-gray-50 border border-gray-200 p-3 mb-4 text-xs font-mono break-words whitespace-pre-wrap overflow-auto max-h-40 text-red-700">
            {errMsg}
            {stack && <details className="mt-2 opacity-60"><summary className="cursor-pointer">Détails techniques</summary>{stack}</details>}
          </div>
          <div className="flex flex-wrap gap-2">
            <button onClick={this.reload} className="btn-primary">Recharger la page</button>
            <button onClick={this.goHome} className="btn-secondary">Retour au tableau</button>
            <button onClick={this.reset} className="btn-ghost">Réessayer</button>
          </div>
        </div>
      </div>
    );
  }
}
